import React, { useState } from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { formatE164USPhoneNumber, formatPhoneAsYouType, stripPhoneNumber } from 'shared';

interface RPhoneInputProps {
    value: string;
    onChange: (e164Value: string, displayValue: string) => void;
    placeholder?: string;
    disabled?: boolean;
    fullWidth?: boolean;
}

export function RPhoneInput({
    value,
    onChange,
    placeholder = '(555) 555-5555',
    disabled,
    fullWidth,
}: RPhoneInputProps) {
    const [display, setDisplay] = useState(() => {
        if (!value) return '';
        const digits = stripPhoneNumber(value);
        return formatPhoneAsYouType(digits);
    });
    const [lastFormatted, setLastFormatted] = useState('');

    function handleChange(raw: string) {
        const digits = stripPhoneNumber(raw);
        const formatted = formatPhoneAsYouType(digits);
        const displayVal = formatted === lastFormatted ? formatted.slice(0, -1) : formatted;
        setLastFormatted(displayVal);
        setDisplay(displayVal);

        const e164 = formatE164USPhoneNumber(digits)?.toString() || digits;
        onChange(e164, displayVal);
    }

    return (
        <StyledInput
            type="tel"
            value={display}
            onChange={(e) => handleChange(e.target.value)}
            placeholder={placeholder}
            disabled={disabled}
            fullWidth={fullWidth}
            maxLength={14}
        />
    );
}

const StyledInput = styled('input')<{ fullWidth?: boolean }>(({ fullWidth }) => ({
    width: fullWidth ? '100%' : 'auto',
    padding: '10px 14px',
    fontSize: 14,
    color: Colors.darkNavy,
    backgroundColor: Colors.faintGrey,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 10,
    outline: 'none',
    boxSizing: 'border-box',
    '&:focus': {
        borderColor: Colors.mediumGrey,
    },
    '&:disabled': {
        backgroundColor: Colors.lightGrey,
        color: Colors.mediumGrey,
    },
    '&::placeholder': {
        color: Colors.lightGrey,
    },
}));
